import { FC, ReactNode } from 'react'

import cn from 'classnames'

import styles from './CardsRow.module.scss'

interface CardsRowProps {
  children: ReactNode
  additionalClassName?: string
}

export const CardsRow: FC<CardsRowProps> = ({
  children,
  additionalClassName
}) => (
  <div className={cn(styles.row, additionalClassName)}>
    <div className={styles.placeholderCard} />
    <div className={styles.centerContent}>{children}</div>
    <div className={styles.placeholderCard} />
  </div>
)
